import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseLandingsPages() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
      pageType: isEmpty(state.pageType),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName || errorState.pageType) {
      enqueueSnackbar("لطفا اطلاعات صفحه لندینگ را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetLandingPages = (search, myPC, bool, callback) => {
    MyAxios.get(`Admin_LandingPages?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetLandingPageByID = (LandingId, callback) => {
    MyAxios.get(`Admin_LandingPages/${LandingId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddLandingPage = (Model, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (file) {
      data.append("Image", file);
    }

    MyAxios.post(`Admin_LandingPages`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن صفحه لندینگ باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateLandingPage = (Model, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (file) {
      data.append("Image", file);
    }
    MyAxios.put(`Admin_LandingPages`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش صفحه لندینگ باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteLandingPage = (LandingID, callback) => {
    const data = new FormData();
    data.append("LandingID", LandingID);
    MyAxios.delete(`Admin_LandingPages`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف صفحه لندینگ باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const GetLandingComponents = (id, callback) => {
    MyAxios.get(`Admin_LandingPages/GetComponents/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetLandingAllComponents = (callback) => {
    MyAxios.get(`Admin_LandingPages/AllComponents`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetLandingComponents = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_LandingPages/SetComponents`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محتوای صفحه لندینگ با موفقیت تنظیم شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const removeLandingComponent = (AID, callback) => {
    const data = new FormData();
    data.append("AID", AID);
    MyAxios.delete(`Admin_LandingPages/RemoveComponent`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کامپوننت با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const GetLandingImages = (landingID, callback) => {
    MyAxios.get(`Admin_LandingPages/Image/${landingID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddLandingImages = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("Image", file);
    }
    MyAxios.post(`Admin_LandingPages/Image`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("تصویر با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveLandingImages = (ImageID, callback) => {
    const data = new FormData();
    data.append("ImageID", ImageID);
    MyAxios.delete(`Admin_LandingPages/Image`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("تصویر با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    GetLandingPages,
    GetLandingPageByID,
    AddLandingPage,
    UpdateLandingPage,
    DeleteLandingPage,
    validate,
    GetLandingComponents,
    GetLandingAllComponents,
    SetLandingComponents,
    removeLandingComponent,
    GetLandingImages,
    AddLandingImages,
    RemoveLandingImages,
  };
}
